import Image from '@components/Image'
import { ElementHTML } from '@helpers/helper.rendering'
import { Link } from 'gatsby'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { RealEstateDataPageComponentData } from 'types'

const AboutUs18 = ({
  title,
  global_data,
  paragraph,
  paragraphElement,
  paragraphHexa,
  paragraphColor,
  titleColor,
  align,
  titleHexa,
  titleElement,
  backgroundHexa,
  image_gatsby,
  button,
}: RealEstateDataPageComponentData) => {
  function ResaltarTexto({ texto }: any) {
    const regex = /\/\/(.*?)\/\//gs // 's' para permitir coincidencias con saltos de línea
    const textoFormateado = texto.replace(regex, '<span class="text-primary">$1</span>')

    return <div dangerouslySetInnerHTML={{ __html: textoFormateado }} />
  }

  return (
    <section
      className={'about-us-19 p-y-config'}
      style={{ background: backgroundHexa }}
    >
      <Container fluid>
        <Row className="align-items-lg-center">
          <Col lg={{ span: image_gatsby ? 6 : 12, order: align === 'right' ? 2 : 1 }}>
            {title && (
              <div className="mb-4 title-section">
                {title.split('\n').map((tit, index) => (
                  <ElementHTML
                    key={index}
                    // children={tit || ''}
                    style={{ color: titleHexa }}
                    className={titleColor + ' title-element'}
                    elementType={titleElement || 'h2'}
                  >
                    <ResaltarTexto texto={tit} />
                  </ElementHTML>
                ))}
              </div>
            )}
            {paragraph && (
              <div className="mb-4">
                {paragraph.split('\n').map((para, index) => (
                  <div
                    key={index}
                    className="d-block"
                  >
                    <ElementHTML
                      children={para || ''}
                      style={{ color: paragraphHexa }}
                      className={paragraphColor + ' paragraph-element '}
                      elementType={paragraphElement || 'p'}
                    />
                  </div>
                ))}
              </div>
            )}
            {button?.link && (
              <Link
                to={button?.link}
                className="btn mt-lg-4 mt-4 btn-primary border"
              >
                {button.value}
                {button?.image && (
                  <img
                    src={button.image}
                    className="ms-2 d-inline-block"
                    alt=""
                  />
                )}
              </Link>
            )}
          </Col>
          {image_gatsby && (
            <Col
              className={align == 'right' ? 'pe-lg-5' : 'ps-lg-5'}
              lg={{ span: 6, order: align === 'right' ? 1 : 2 }}
            >
              <Image
                image={image_gatsby!}
                objectFit="cover"
                alt="img-aboutus-19"
                className="w-100 d-lg-block d-none"
              />
            </Col>
          )}
        </Row>
      </Container>
    </section>
  )
}

export default AboutUs18
